import { render, staticRenderFns } from "./GroupTagTooltip.vue?vue&type=template&id=791f7cdd&"
import script from "./GroupTagTooltip.vue?vue&type=script&lang=js&"
export * from "./GroupTagTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports